import {Module} from 'vuex';
import {RootState} from '../types';
import {ListsState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: ListsState = {
  originatorStatusList: [
    {text: 'Разрешен', value: 'ACCEPTED'},
    {text: 'На рассмотрении', value: 'UNDER_CONSIDERATION'},
    {text: 'Запрещен', value: 'DENIED'},
  ],
  templatesStatusList: [
    {text: 'Ожидает модерации', value: 'ForModeration'},
    {text: 'На рассмотрении', value: 'OnModeration'},
  ],
  messagesStatusList: [
    'Failed',
    'Rejected',
    'NotDelivered',
    'Delivered',
    'Deferred',
    'Expired',
    'Transmitted',
  ],
  pushMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Failed',
    'Rejected',
    'Expired',
    'Deferred',
  ],
  smsMessagesStatusList: [
    'Error',
    'Processed',
  ],
  callMessagesStatusList: [
    'Error',
    'Finished',
    'Rejected',
    'NotAnswered',
    'Buffered',
  ],
  emailMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  viberMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Expired',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  whatsappMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Expired',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  customMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Expired',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  mnMessagesStatusList: [
    'Failed',
    'Rejected',
    'NotDelivered',
    'Delivered',
    'Deferred',
    'Expired',
    'Transmitted',
    'Read',
  ],
  priorityList: [
    {text: 'Low', value: 2},
    {text: 'Normal', value: 4},
    {text: 'High', value: 6},
    {text: 'Realtime', value: 8},
  ],
  smsFilterConditionsList: [
    {text: 'Равно', value: 'eq'},
    {text: 'Не равно', value: '!eq'},
    {text: 'Содержит', value: 'in'},
    {text: 'Не содержит', value: '!in'},
  ],
  delimiterList: [
    {text: 'Запятая', value: ','},
    {text: 'Точка с запятой', value: ';'},
    {text: 'Пробел', value: ' '},
    {text: 'Точка', value: '.'},
    {text: 'Двоеточие', value: ':'},
  ],
  restrictionsList: [
    {text: 'Только буквенные', value: 'alpha'},
    {text: 'Только числовые', value: 'numeric'},
    {text: 'Заданные', value: 'allowed'},
  ],
  devicesList: [
    {text: 'Все', value: 'ALL'},
    {text: 'Только последнее', value: 'ONLY_LAST'},
  ],
};


export const lists: Module<ListsState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
